import React from "react";
import AppChoicesContext from "../../context/AppChoicesContext";
import CachedResponse from "../CachedResponse";

export const RESTRICTED_APP_CHOICES_ROUTES = [
  "/admin/counties",
  "/admin/app-choices",
  "/login",
];

const AppChoicesProvider = ({ children }) => {
  return (
    <CachedResponse
      listEndpoint={"app-choices"}
      restrictedRoutes={[...RESTRICTED_APP_CHOICES_ROUTES]}
      render={(appChoices) => (
        <AppChoicesContext.Provider value={appChoices}>
          {children}
        </AppChoicesContext.Provider>
      )}
    />
  );
};

export default AppChoicesProvider;
